"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTableData = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const react_router_1 = require("react-router");
const uiConstants_1 = require("../../../../../constants/uiConstants");
const companyQuery_1 = require("../../../../../queries/companyQuery");
const paymentQuery_1 = require("../../../../../queries/paymentQuery");
const userQuery_1 = require("../../../../../queries/userQuery");
const walletQuery_1 = require("../../../../../queries/walletQuery");
const dateUtils_1 = require("../../../../../utils/dateUtils");
const zustandStore_1 = require("../../../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../../../atoms/button/simpleButton"));
const walletDetails_1 = require("../../../wallet/component/walletDetails");
const helpers_1 = __importDefault(require("../../helpers"));
const useGetTableData = () => {
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: currentUser } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        initialData: initialData.userData,
    });
    const { data: companyFeatures } = (0, react_query_1.useQuery)(companyQuery_1.companyFeaturesQuery);
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)({
        ...(0, companyQuery_1.companyPropertiesQuery)(currentUser?.companyAccountId, {
            cardprovider: 'tsgo-cardprovider',
        }),
        initialData: initialData.companyPropertiesData,
    });
    const cardProvider = companyPropertiesData?.cardprovider;
    const isAmexCardProvider = cardProvider === 'AMEX';
    const { setWalletCardDetailAside, setIsWalletCardDetailAsideOpen, setViewReceiptsAsideSettlement, setIsViewReceiptsAsideOpen, settlement, aside, } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const { settlements, page } = settlement;
    const { walletCardDetailAside: walletCardDetailsAside } = aside;
    const LIMIT = 20;
    const [selectedVirtualId, setSelectedVirtualId] = (0, react_1.useState)('');
    const { data: wallet, refetch: refetchVirtualCardTask } = (0, react_query_1.useQuery)((0, walletQuery_1.virtualCardTask)(selectedVirtualId));
    const isCardOwner = wallet?.context?.request?.requester?.userId === initialData.userData.userId;
    const { data: card, refetch: refetchVirtualCardData } = (0, react_query_1.useQuery)((0, paymentQuery_1.virtualCardDataQuery)(wallet?.subjectId || '', isCardOwner));
    (0, react_1.useEffect)(() => {
        if (selectedVirtualId) {
            void refetchVirtualCardTask();
        }
    }, [selectedVirtualId]);
    (0, react_1.useEffect)(() => {
        if (wallet?.subjectId) {
            void refetchVirtualCardData();
        }
    }, [wallet?.subjectId]);
    (0, react_1.useEffect)(() => {
        if (card && (card?.['id'] || card?.['info']?.id)) {
            setIsWalletCardDetailAsideOpen(true);
            const cardInfo = { ...wallet, card };
            setWalletCardDetailAside(cardInfo);
        }
    }, [card]);
    (0, react_1.useEffect)(() => {
        if (!walletCardDetailsAside.isOpen) {
            setSelectedVirtualId('');
        }
    }, [walletCardDetailsAside.isOpen]);
    if (settlements.length > 0) {
        return (LIMIT > 0 ? settlements.slice((page - 1) * LIMIT, (page - 1) * LIMIT + LIMIT) : settlements).map(settlement => [
            {
                id: 'date',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(walletDetails_1.TypographyFieldData, { children: settlement.date ? (0, dateUtils_1.formatDate)(settlement.date, currentUser?.language) : 'N/A' }));
                },
                visible: true,
            },
            {
                id: 'amount',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(walletDetails_1.TypographyFieldData, { sx: { textAlign: 'right', paddingRight: '10px' }, children: settlement.totalAmount || 0 }));
                },
                visible: true,
            },
            {
                id: 'details',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { sx: { width: '200px', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }, children: (0, jsx_runtime_1.jsx)(walletDetails_1.TypographyFieldData, { children: settlement?.merchant?.name }) }));
                },
                visible: true,
            },
            {
                id: 'user',
                ui() {
                    return (0, jsx_runtime_1.jsx)(walletDetails_1.TypographyFieldData, { children: settlement?.cardInfo?.userInfo?.name });
                },
                visible: true,
            },
            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                ? []
                : [
                    {
                        id: 'coding',
                        ui() {
                            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { sx: { width: '200px', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }, children: (0, jsx_runtime_1.jsx)(walletDetails_1.TypographyFieldData, { children: helpers_1.default
                                        .generateCodingInfoRow(settlement.codingInfo)
                                        .split('\n')
                                        .map((str, index) => ((0, jsx_runtime_1.jsx)(material_1.Typography, { children: str }, index))) }) }));
                        },
                        visible: true,
                    },
                ]),
            {
                id: 'receipt',
                ui() {
                    return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "row", sx: {
                            justifyContent: 'flex-start',
                        }, children: companyFeatures?.['ENABLE_TRANSACTION_RECEIPT_UPLOAD'] && ((0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "viewReceipt-btn", color: settlement.receiptId ? uiConstants_1.UI_BUTTON_SECONDARY : uiConstants_1.UI_BUTTON_PRIMARY, size: "small", onClick: () => {
                                setViewReceiptsAsideSettlement(settlement);
                                setIsViewReceiptsAsideOpen(true);
                            }, label: settlement.receiptId ? 'View Receipt' : 'Add Receipt' })) }));
                },
                visible: initialData.showReceiptUpload && isAmexCardProvider,
            },
            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                ? []
                : [
                    {
                        id: 'settlementActions',
                        ui() {
                            return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "row", sx: {
                                    justifyContent: 'flex-start',
                                }, children: (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "viewCardDetails-btn", color: uiConstants_1.UI_BUTTON_SECONDARY, size: "small", onClick: () => {
                                        setSelectedVirtualId(settlement.cardId);
                                    }, label: 'View Card' }) }));
                        },
                        visible: true,
                    },
                ]),
        ]);
    }
    return [];
};
exports.useGetTableData = useGetTableData;
